import React, { FunctionComponent } from "react";
import { generatePath, RouteComponentProps, withRouter } from "react-router";
import { BlogPost } from "services/entities/content";
import { Button, Typography } from "@material-ui/core";
import RouteURLs from "RouteURLs";
import "./index.scss";

interface BlogPostCardProps extends RouteComponentProps {
  blogPost: BlogPost;
  displayActions?: boolean;
  highlighted?: string | null;
  image?: URL | null; // Image dimensions 900 x 826
  shortTitle?: string | null;
  text?: string;
  link?: URL | null;
  stats?: {
    number: string;
    text: string;
  }[];
}

export const BlogPostCard: FunctionComponent<BlogPostCardProps> = ({
  blogPost,
  history,
  highlighted,
  image,
  shortTitle,
  text,
  link,
  stats,
}) => {
  const onViewPostClick = (post: BlogPost) => {
    if (post.content) {
      history.push(
        generatePath(RouteURLs.VIEW_BLOG_DETAIL, { code: post.code })
      );
    } else if (post.url) {
      window.open(post.url.href);
    }
  };
  // const onViewReportClick = (post: BlogPost) => {
  //   history.push(generatePath(RouteURLs.VIEW_BLOG_REPORT, { code: post.code }));
  // };

  const truncate = () =>
    shortTitle && shortTitle.length > 100
      ? `${shortTitle.substring(0, 100)}...`
      : shortTitle;

  return (
    <article className="component--blog-post-card" onClick={() => onViewPostClick(blogPost)}>
      <div className="wrapper">
        <div className="left">
          {image && (
            <div className="image-wrapper">
              <img src={image.href} className="hero" alt="" />
            </div>
          )}
        </div>
        <div className="right">
          <div className="inner">
            <Typography className="title" variant="h4" component="h4">
              <span className="companyName">{highlighted}</span>
            </Typography>
            <Typography className="text" variant="body1" component="div">
            {truncate()}
            </Typography>
              <Button
                size="small"
                component="span"
                onClick={() => onViewPostClick(blogPost)}
                className="button"
              >
                Read More
              </Button>
          </div>
        </div>
      </div>
    </article>
  );
};

export default withRouter(BlogPostCard);
